//TODO: this file should be cleaned up, why do we still need to encode \n or \t
// or why do we escape \\ to \\\\ but not vice versa (this causes UNC network shares to fail (i.e. \\my-network-share\folder

const textAreaControls = ["template", "tables", "augumentqueryclause", "sobjects"];

// Properties the UI must pre-double backslashes for, because the backend does NOT TQL-escape
// them through escapePropertyValueString:
//   "password" → pulled out and handled separately (encryption) in the backend serializer, so
//                the UI still pre-doubles: user types 12345\6, server must receive 12345\\6
//                (DEV-22056, DEV-51472)
const NEEDS_BACKSLASH_DOUBLING = ["password"];

// Properties the UI must leave completely untouched in both directions:
//   "directory" / "Tables" / "ExcludedTables"
//        → the backend TQL-escapes these via escapePropertyValueString (doubles backslashes,
//          parser halves on read — symmetric). The UI must NOT apply the normal \t/\n/\r →
//          control-char conversion here: it would corrupt paths like C:\temp (backslash-t
//          would become a real tab). Pass through; the user sees exactly what they typed
//          (WYSIWYG). (DEV-23231 / DEV-52582 / DEV-20673)
//
// NOTE: FindAndReplaceDDL is NOT in this list. The backend gives it no special treatment —
//   it goes through escapePropertyValueString like any normal property, so the UI must also
//   treat it as normal (\t/\n/\r literal → real char conversion applies).
const SKIP_ALL_TRANSFORMATIONS = ["Tables", "ExcludedTables", "directory"];

function getPropertyCategory(propertyName) {
    var lower = propertyName.toLowerCase();
    if (SKIP_ALL_TRANSFORMATIONS.some(function(n) { return n.toLowerCase() === lower; })) {
        return "skip";
        
    }
    if (NEEDS_BACKSLASH_DOUBLING.some(function(n) { return n.toLowerCase() === lower; })) {
        return "double";
    }
    return "normal";
}

// when reading
function unescapeSpecialCharacters(text, propertyName) {
    text = text.replaceAll(String.fromCharCode(9), "\\t");
    if (textAreaControls.indexOf(propertyName.toLowerCase()) === -1)
        text = text.replaceAll(String.fromCharCode(10), "\\n");
    text = text.replaceAll(String.fromCharCode(13), "\\r");
    return text;
}

// For password: double every backslash before sending to the backend. Passwords are pulled
// out and handled separately by the backend serializer (encryption) and are NOT run through
// escapePropertyValueString, so the TQL parser's \\→\ halving is the only transformation —
// doubling here keeps the user's original value intact on round-trip (WYSIWYG).
function doubleBackslashes(text) {
    return text.replace(/\\/g, "\\\\");
}

// When Saving (normal properties only — those routed through escapePropertyValueString):
// Convert escape literals (\t, \n, \r) to real characters. The backend then doubles
// backslashes and the TQL parser halves them — net identity for the user's backslashes.
// Do NOT touch backslashes here (DEV-49716, DEV-58559: first-backslash doubling caused
// values to grow on every save).
function escapeSpecialCharacters(text) {
    text = text.replaceAll("\\t", String.fromCharCode(9));
    text = text.replaceAll("\\n", String.fromCharCode(10));
    text = text.replaceAll("\\r", String.fromCharCode(13));
    return text;
}

function escapeObjectProperties(object) {
    if (object && object.properties) {
        var properties = object.properties;
        Object.keys(properties).forEach(function(propertyName) {
            var propertyValue = properties[propertyName];
            if (typeof propertyValue !== "string") return;
            var category = getPropertyCategory(propertyName);
            if (category === "skip") return;
            if (category === "double") {
                properties[propertyName] = doubleBackslashes(propertyValue);
            } else {
                properties[propertyName] = escapeSpecialCharacters(propertyValue);
            }
        });
    }
}

function unescapeObjectProperties(object) {
    if (object) {
        var properties = object.properties;
        Object.keys(properties).forEach(function(propertyName) {
            var propertyValue = properties[propertyName];
            if (typeof propertyValue !== "string") return;
            var category = getPropertyCategory(propertyName);
            // "skip": raw TQL/DDL, never touch
            // "double": backend round-trip is already symmetric after the save-time doubling
            if (category === "skip" || category === "double") return;
            properties[propertyName] = unescapeSpecialCharacters(propertyValue, propertyName);
        });
    }
}

// CONNECTIONPROFILE stores properties as [{name, value}] rather than a plain object.
// These two functions apply the same category logic to that array format.
function escapeArrayProperties(propertiesArray) {
    propertiesArray.forEach(function(prop) {
        if (!prop || typeof prop.name !== "string" || typeof prop.value !== "string") return;
        var category = getPropertyCategory(prop.name);
        if (category === "skip") return;
        if (category === "double") {
            prop.value = doubleBackslashes(prop.value);
        } else {
            prop.value = escapeSpecialCharacters(prop.value);
        }
    });
}

function unescapeArrayProperties(propertiesArray) {
    propertiesArray.forEach(function(prop) {
        if (!prop || typeof prop.name !== "string" || typeof prop.value !== "string") return;
        var category = getPropertyCategory(prop.name);
        if (category === "skip" || category === "double") return;
        prop.value = unescapeSpecialCharacters(prop.value, prop.name);
    });
}

export default {
    // when saving..
    escapeMetaObject: function(metaObject) {
        if (!metaObject) {
            return;
        }
        escapeObjectProperties(metaObject.adapter);
        escapeObjectProperties(metaObject.parser);
        escapeObjectProperties(metaObject.formatter);
        // CONNECTIONPROFILE: properties is a flat [{name, value}] array
        if (Array.isArray(metaObject.properties)) {
            escapeArrayProperties(metaObject.properties);
        }
    },
    unescapeMetaObject: function(metaObject) {
        if (!metaObject) {
            return;
        }
        unescapeObjectProperties(metaObject.adapter, metaObject.type);
        unescapeObjectProperties(metaObject.parser, metaObject.type);
        unescapeObjectProperties(metaObject.formatter, metaObject.type);
        // CONNECTIONPROFILE: properties is a flat [{name, value}] array
        if (Array.isArray(metaObject.properties)) {
            unescapeArrayProperties(metaObject.properties);
        }
    }
};
